export { default } from './SpotlightBankFilter';
